module.exports = __webpack_public_path__ + "img/romans-empire.58f0c232.png";